/**
 * Created by ivo on 12.01.17.
 */

import React from 'react';
import PropTypes from "prop-types";
import $ from 'jquery';

/**
 * Common modal class
 */


/**
 * Usage:
 * import Modal from './Bootstrap/Modal';
 *
 * <Modal id='' modalClass='' dialogClass=''>
 *     <Modal.Header></Modal.Header>
 *     <Modal.Body></Modal.Body>
 *     <Modal.Footer></Modal.Footer>
 * </Modal>
 *
 */
class Modal extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        modalClass: PropTypes.string,
        /**
         * Additional attributes added to the modal div element.
         */
        modalAttrib: PropTypes.object,
        dialogClass: PropTypes.string,
        /**
         * Called when modal was asked to hide. This callback will not be called on case of unmount of this component
         */
        onClose: PropTypes.func,
        /**
         * Modal visibility state. By default this is true - modal is visible when created.
         */
        show: PropTypes.bool,
        /**
         * Modal content
         */
        children: PropTypes.any.isRequired
    };

    static defaultProps = {
        id: 'modal',
        modalClass: 'fade',
        dialogClass: '',
        show: true
    };

    componentDidMount() {
        $('#' + this.props.id).on('hide.bs.modal', function (e) {
            // Modal was requested to hide. Exit from this component:
            if (this.props.onClose) this.props.onClose();
        }.bind(this));

        if (this.props.show) $('#' + this.props.id).modal('show');
        else $('#' + this.props.id).modal('hide');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.show !== this.props.show) {
            if (this.props.show) $('#' + this.props.id).modal('show');
            else $('#' + this.props.id).modal('hide');
        }
    }

    componentWillUnmount() {
        $('#' + this.props.id).off('hide.bs.modal');
        $('#' + this.props.id).modal('hide');
    }

    render() {
        return (
            <div id={this.props.id} className={"modal " + this.props.modalClass} {...this.props.modalAttrib} tabIndex="-1" role="dialog">
                <div className={"modal-dialog " + this.props.dialogClass} role="document">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

class ModalContent extends React.Component {
    render() {
        return (
            <div className="modal-content">
                {this.props.children}
            </div>
        );
    }
}

class ModalHeader extends React.Component {
    render() {
        return (
            <div className="modal-header">
                {this.props.children}
            </div>
        );
    }
}

class ModalBody extends React.Component {
    render() {
        return (
            <div className="modal-body">
                {this.props.children}
            </div>
        );
    }
}

class ModalFooter extends React.Component {
    render() {
        return (
            <div className="modal-footer">
                {this.props.children}
            </div>
        );
    }
}

Modal.Content = ModalContent;
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
